(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us"] && !Shopify.designMode) return;
  try {
    
  function j1InitCountUp() {
    var els = document.querySelectorAll('.j1-countup:not([data-counted])');
    if (!els.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        j1AnimateCount(entry.target, reduceMotion);
      });
    }, { threshold: 0.4 });

    els.forEach(function (el) {
      el.setAttribute('data-counted', 'true');
      observer.observe(el);
    });
  }

  function j1AnimateCount(el, reduceMotion) {
    var raw = el.getAttribute('data-count') || '';
    var match = raw.match(/^([\d,.]+)(.*)$/);

    if (!match || reduceMotion) {
      el.textContent = raw;
      return;
    }

    var numPart = match[1];
    var suffix = match[2];
    var hasComma = numPart.indexOf(',') !== -1;
    var decimalMatch = numPart.match(/\.(\d+)/);
    var decimals = decimalMatch ? decimalMatch[1].length : 0;
    var endValue = parseFloat(numPart.replace(/,/g, ''));

    if (isNaN(endValue)) {
      el.textContent = raw;
      return;
    }

    var duration = 1500;
    var startTime = null;

    function format(value) {
      var fixed = value.toFixed(decimals);
      if (!hasComma) return fixed + suffix;
      var fixedParts = fixed.split('.');
      fixedParts[0] = fixedParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fixedParts.join('.') + suffix;
    }

    function step(timestamp) {
      if (startTime === null) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(endValue * eased);
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = raw;
      }
    }

    requestAnimationFrame(step);
  }

  j1InitCountUp();
  document.addEventListener('shopify:section:load', j1InitCountUp);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["app-integration"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-app-integration]');
    roots.forEach(function (root) {
      if (root.dataset.appInit === 'true') return;
      root.dataset.appInit = 'true';

      var screens = root.querySelectorAll('[data-app-screen]');
      var tabs = root.querySelectorAll('[data-app-tab]');
      var features = root.querySelectorAll('[data-app-feature]');
      var grid = root.querySelector('[data-app-grid]');
      var glow = root.querySelector('[data-app-glow]');
      var aura = root.querySelector('[data-app-aura]');

      var featureData = [];
      features.forEach(function (f) {
        featureData.push({
          el: f,
          index: parseInt(f.getAttribute('data-feature-index'), 10),
          screen: parseInt(f.getAttribute('data-feature-screen'), 10),
          color: f.getAttribute('data-feature-color') || 'var(--color-success)'
        });
      });

      var activeFeature = 0;
      var activeScreen = 0;
      var paused = false;
      var timer = null;

      function showScreen(idx) {
        activeScreen = idx;
        screens.forEach(function (s) {
          if (parseInt(s.getAttribute('data-app-screen'), 10) === idx) {
            s.classList.remove('hidden');
          } else {
            s.classList.add('hidden');
          }
        });
        tabs.forEach(function (t) {
          var isOn = parseInt(t.getAttribute('data-app-tab'), 10) === idx;
          t.classList.toggle('bg-zinc-950', isOn);
          t.classList.toggle('text-white', isOn);
          t.classList.toggle('text-zinc-600', !isOn);
          t.classList.toggle('hover:text-zinc-900', !isOn);
        });
      }

      function setActiveFeature(idx) {
        activeFeature = idx;
        featureData.forEach(function (d) {
          var on = d.index === idx;
          d.el.classList.toggle('is-active', on);
          d.el.classList.toggle('border-zinc-200/60', !on);
          d.el.classList.toggle('hover:bg-white/40', !on);
          d.el.classList.toggle('hover:border-zinc-200', !on);
          d.el.style.borderColor = on ? 'var(--feat-color)' : '';

          if (on) {
            if (glow) glow.style.background = 'radial-gradient(circle, ' + d.color + ' 0%, transparent 70%)';
            if (aura) aura.style.backgroundColor = d.color;
          }

          var title = d.el.querySelector('.app-feature__title');
          if (title) {
            title.classList.toggle('text-zinc-950', on);
            title.classList.toggle('text-zinc-800', !on);
          }
          var icon = d.el.querySelector('.app-feature__icon');
          if (icon) {
            icon.style.backgroundColor = on ? 'color-mix(in srgb, var(--feat-color) 8%, transparent)' : '#f4f4f5';
          }
          var overlay = d.el.querySelector('.app-feature__overlay');
          if (overlay) {
            overlay.style.opacity = on ? '0.03' : '0';
          }
          var badge = d.el.querySelector('.app-feature__badge');
          if (badge) {
            badge.classList.toggle('hidden', !on);
          }
          var line = d.el.querySelector('.app-feature__line');
          if (line) {
            line.classList.toggle('scale-x-100', on);
            line.classList.toggle('scale-x-0', !on);
            line.classList.toggle('group-hover:scale-x-50', !on);
          }
        });
      }

      function startTimer() {
        stopTimer();
        timer = setInterval(function () {
          if (paused) return;
          var next = (activeFeature + 1) % featureData.length;
          setActiveFeature(next);
          showScreen(featureData[next].screen);
        }, 3500);
      }

      function stopTimer() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          paused = true;
          var idx = parseInt(t.getAttribute('data-app-tab'), 10);
          showScreen(idx);
          for (var i = 0; i < featureData.length; i++) {
            if (featureData[i].screen === idx) {
              setActiveFeature(featureData[i].index);
              break;
            }
          }
        });
      });

      features.forEach(function (f) {
        f.addEventListener('click', function () {
          paused = true;
          var idx = parseInt(f.getAttribute('data-feature-index'), 10);
          var scr = parseInt(f.getAttribute('data-feature-screen'), 10);
          setActiveFeature(idx);
          showScreen(scr);
        });
      });

      if (grid) {
        grid.addEventListener('mouseenter', function () { paused = true; });
        grid.addEventListener('mouseleave', function () { paused = false; });
      }

      setActiveFeature(0);
      showScreen(0);
      startTimer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    var bar = document.querySelector('[data-jarticle-progress]');
    var body = document.querySelector('[data-jarticle-body]');
    if (!bar || !body) return;

    var ticking = false;

    function update() {
      ticking = false;
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight * 0.4;
      var scrolled = window.innerHeight * 0.6 - rect.top;
      var ratio = total > 0 ? scrolled / total : 0;
      bar.style.transform = 'scaleX(' + Math.min(Math.max(ratio, 0), 1) + ')';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    document.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["best-sellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-best-sellers]').forEach(function (root) {
      var track = root.querySelector('[data-bs-track]');
      var prev = root.querySelector('[data-bs-prev]');
      var next = root.querySelector('[data-bs-next]');
      if (!track) return;

      var step = 324;

      function atEnd() {
        return track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
      }

      function scrollNext() {
        if (atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: step, behavior: 'smooth' });
        }
      }

      function scrollPrev() {
        if (track.scrollLeft <= 0) {
          track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: -step, behavior: 'smooth' });
        }
      }

      if (prev) prev.addEventListener('click', scrollPrev);
      if (next) next.addEventListener('click', scrollNext);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-section"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBlogSlider(root) {
      if (root.dataset.blogSliderReady) return;
      root.dataset.blogSliderReady = 'true';

      var track = root.querySelector('[data-blog-track]');
      var prev = root.querySelector('[data-blog-prev]');
      var next = root.querySelector('[data-blog-next]');
      var sectionId = root.dataset.sectionId;
      if (!track) return;

      var loadingPromise = null;
      var ticking = false;

      function sentinel() {
        return track.querySelector('[data-blog-sentinel]');
      }

      function hasMore() {
        return !!sentinel();
      }

      function step() {
        var card = track.querySelector('.blog-slider-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function maxScroll() {
        return track.scrollWidth - track.clientWidth;
      }

      function atStart() {
        return track.scrollLeft <= 4;
      }

      // The loader sentinel sits after the last card, so "end" means the last
      // card is fully visible — not that the spinner has scrolled into view.
      function atEnd() {
        var marker = sentinel();
        var limit = maxScroll();
        if (marker) limit -= marker.offsetWidth + (parseFloat(getComputedStyle(track).columnGap) || 0);
        return track.scrollLeft >= limit - 4;
      }

      function nearEnd() {
        return maxScroll() - track.scrollLeft <= track.clientWidth * 1.5;
      }

      function updateArrows() {
        if (prev) prev.disabled = atStart();
        if (next) next.disabled = atEnd() && !hasMore();
      }

      function existingUrls() {
        var urls = {};
        track.querySelectorAll('.blog-slider-card').forEach(function (card) {
          urls[card.getAttribute('href')] = true;
        });
        return urls;
      }

      function loadMore() {
        if (loadingPromise) return loadingPromise;
        var marker = sentinel();
        if (!marker) return Promise.resolve(false);

        var url = new URL(marker.dataset.nextUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);
        root.setAttribute('aria-busy', 'true');

        loadingPromise = fetch(url.toString())
          .then(function (res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newTrack = doc.querySelector('[data-blog-track]');
            if (!newTrack) throw new Error('Missing slider track in response');

            var seen = existingUrls();
            var fragment = document.createDocumentFragment();
            var added = 0;

            newTrack.querySelectorAll('.blog-slider-card').forEach(function (card) {
              var href = card.getAttribute('href');
              if (seen[href]) return;
              seen[href] = true;
              fragment.appendChild(document.importNode(card, true));
              added++;
            });

            var newMarker = newTrack.querySelector('[data-blog-sentinel]');
            track.insertBefore(fragment, marker);

            // Keep going only when the page returned new articles and says
            // there is another page; otherwise we have reached the last one.
            if (added > 0 && newMarker && newMarker.dataset.nextUrl !== marker.dataset.nextUrl) {
              marker.dataset.nextUrl = newMarker.dataset.nextUrl;
            } else {
              marker.remove();
            }
            return added > 0;
          })
          .catch(function (error) {
            // Keep the sentinel so the next scroll or click retries.
            console.warn('Blog slider: could not load more articles', error);
            return false;
          })
          .finally(function () {
            loadingPromise = null;
            root.removeAttribute('aria-busy');
            updateArrows();
          });

        return loadingPromise;
      }

      function scrollNext() {
        if (!atEnd()) {
          track.scrollBy({ left: step(), behavior: 'smooth' });
          return;
        }
        if (!hasMore()) return;
        var from = track.scrollLeft;
        loadMore().then(function (added) {
          if (added) track.scrollTo({ left: from + step(), behavior: 'smooth' });
        });
      }

      function scrollPrev() {
        if (atStart()) return;
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      }

      function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          if (hasMore() && nearEnd()) loadMore();
          updateArrows();
        });
      }

      if (prev) prev.addEventListener('click', scrollPrev);
      if (next) next.addEventListener('click', scrollNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      // Lazy: fetch the next page once the section comes into view.
      if (hasMore() && 'IntersectionObserver' in window) {
        var viewObserver = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              viewObserver.disconnect();
              if (nearEnd()) loadMore();
            }
          },
          { rootMargin: '200px 0px' }
        );
        viewObserver.observe(root);
      }

      updateArrows();
    }

    function initAll() {
      document.querySelectorAll('[data-blog-slider]').forEach(initBlogSlider);
    }

    initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-cart-page-root]').forEach(function (root) {
      if (root.dataset.cartPageInit === '1') return;
      root.dataset.cartPageInit = '1';

      var sectionId = root.id.replace('cart-page-', '');
      var content = root.querySelector('[data-cart-page-content]');
      var noteStatusTimer = null;

      function setBusy(busy) {
        root.classList.toggle('is-updating', busy);
      }

      function swap(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(content.id);
        if (fresh) content.innerHTML = fresh.innerHTML;
      }

      function syncHeader() {
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.toggle('hidden', cart.item_count === 0);
            });
            if (window.J1Cart && window.J1Cart.refresh) window.J1Cart.refresh();
          });
      }

      function refresh() {
        setBusy(true);
        return fetch('/cart?section_id=' + sectionId)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            swap(html);
            return syncHeader();
          })
          .finally(function () { setBusy(false); });
      }

      function changeLine(key, quantity) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity })
        }).then(refresh);
      }

      root.addEventListener('click', function (e) {
        var line = e.target.closest('[data-cart-line]');

        var removeBtn = e.target.closest('[data-cart-remove]');
        if (removeBtn && line) {
          changeLine(line.getAttribute('data-cart-line'), 0);
          return;
        }

        var minusBtn = e.target.closest('[data-cart-decrease]');
        if (minusBtn && line) {
          var input = line.querySelector('[data-cart-qty-input]');
          var next = Math.max(0, parseInt(input.value, 10) - 1);
          changeLine(line.getAttribute('data-cart-line'), next);
          return;
        }

        var plusBtn = e.target.closest('[data-cart-increase]');
        if (plusBtn && line) {
          var input2 = line.querySelector('[data-cart-qty-input]');
          var next2 = parseInt(input2.value, 10) + 1;
          changeLine(line.getAttribute('data-cart-line'), next2);
          return;
        }

        var saveNoteBtn = e.target.closest('[data-cart-save-note]');
        if (saveNoteBtn) {
          var textarea = root.querySelector('[data-cart-note]');
          var status = root.querySelector('[data-cart-note-status]');
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: textarea.value })
          }).then(function () {
            if (!status) return;
            status.classList.remove('opacity-0');
            if (noteStatusTimer) clearTimeout(noteStatusTimer);
            noteStatusTimer = setTimeout(function () { status.classList.add('opacity-0'); }, 2000);
          });
        }
      });

      root.addEventListener('change', function (e) {
        var input = e.target.closest('[data-cart-qty-input]');
        if (!input) return;
        var line = input.closest('[data-cart-line]');
        if (!line) return;
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(line.getAttribute('data-cart-line'), qty);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-collection-reviews]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-cr-filter]');
      var cards = root.querySelectorAll('[data-j1-review]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var filter = tab.getAttribute('data-cr-filter');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          cards.forEach(function (card) {
            card.style.display = (filter === 'all' || card.getAttribute('data-rating') === filter) ? '' : 'none';
          });
        });
      });

      root.querySelectorAll('[data-j1-helpful]').forEach(function (btn) {
        var counted = false;
        btn.addEventListener('click', function () {
          if (counted) return;
          counted = true;
          var count = btn.querySelector('[data-j1-helpful-count]');
          if (count) count.textContent = parseInt(count.textContent, 10) + 1;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-shop-collection]').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-shop-card]'));
    var versionButtons = Array.prototype.slice.call(root.querySelectorAll('[data-shop-version]'));
    var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-shop-category]'));
    var countEl = root.querySelector('[data-shop-count]');
    var emptyEl = root.querySelector('[data-shop-empty]');
    var paginationEl = root.querySelector('[data-shop-pagination]');
    var resetButton = root.querySelector('[data-shop-reset]');

    var state = { version: 'all', category: 'all' };

    function isFiltering() {
      return state.version !== 'all' || state.category !== 'all';
    }

    function applyFilters() {
      var visible = 0;
      cards.forEach(function (card) {
        var matchesVersion = state.version === 'all' || card.dataset.version === state.version;
        var matchesCategory = state.category === 'all' || card.dataset.type === state.category;
        var show = matchesVersion && matchesCategory;
        card.classList.toggle('hidden', !show);
        if (show) visible++;
      });

      if (countEl) countEl.textContent = visible;
      if (emptyEl) emptyEl.classList.toggle('hidden', visible > 0);
      if (paginationEl) paginationEl.classList.toggle('hidden', isFiltering());
    }

    function setActive(buttons, activeButton) {
      buttons.forEach(function (btn) {
        btn.classList.toggle('is-active', btn === activeButton);
      });
    }

    versionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.version = btn.dataset.shopVersion;
        setActive(versionButtons, btn);
        applyFilters();
      });
    });

    categoryButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.category = btn.dataset.shopCategory;
        setActive(categoryButtons, btn);
        applyFilters();
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        state.version = 'all';
        state.category = 'all';
        setActive(versionButtons, versionButtons[0]);
        setActive(categoryButtons, categoryButtons[0]);
        applyFilters();
      });
    }

    /* Predictive search — fetches the predictive-search section via the
       Section Rendering API and shows results in a dropdown panel. */
    var searchInput = root.querySelector('[data-shop-search]');
    var suggestPanel = root.querySelector('[data-shop-suggest]');
    var predictiveUrl = root.dataset.predictiveUrl;

    if (searchInput && suggestPanel && predictiveUrl) {
      var debounceTimer = null;
      var requestId = 0;

      function closeSuggest() {
        suggestPanel.classList.add('hidden');
        searchInput.setAttribute('aria-expanded', 'false');
      }

      function openSuggest() {
        if (suggestPanel.innerHTML.trim() !== '') {
          suggestPanel.classList.remove('hidden');
          searchInput.setAttribute('aria-expanded', 'true');
        }
      }

      function fetchSuggestions(query) {
        var currentRequest = ++requestId;
        var url =
          predictiveUrl +
          '?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=8&section_id=predictive-search';

        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            if (currentRequest !== requestId) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('[data-predictive-results]');
            if (results) {
              suggestPanel.innerHTML = results.innerHTML;
              openSuggest();
            } else {
              suggestPanel.innerHTML = '';
              closeSuggest();
            }
          })
          .catch(function () {
            closeSuggest();
          });
      }

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim();
        clearTimeout(debounceTimer);

        if (query === '') {
          requestId++;
          suggestPanel.innerHTML = '';
          closeSuggest();
          return;
        }

        debounceTimer = setTimeout(function () {
          fetchSuggestions(query);
        }, 250);
      });

      searchInput.addEventListener('focus', openSuggest);

      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeSuggest();
      });

      document.addEventListener('click', function (event) {
        if (!searchInput.closest('[data-shop-search-form]').contains(event.target)) {
          closeSuggest();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flash-deals"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[id^="flash-deals-"]');
    sections.forEach(function (section) {
      if (section.dataset.flashInit === 'true') return;
      section.dataset.flashInit = 'true';

      /* ── Countdown ── */
      var countdown = section.querySelector('[data-flash-countdown]');
      if (countdown) {
        var target = null;

        /* Fixed target date/time (e.g. "2026-07-15 18:00"). Falls back to a
         * rolling duration when empty or unparseable. */
        var targetAttr = section.getAttribute('data-countdown-target');
        if (targetAttr) {
          var parsed = Date.parse(targetAttr.trim().replace(' ', 'T'));
          if (!isNaN(parsed)) target = parsed;
        }

        if (target === null) {
          var hoursSetting = parseFloat(section.getAttribute('data-countdown-hours')) || 12;
          target = Date.now() + hoursSetting * 60 * 60 * 1000;
        }

        var elD = countdown.querySelector('[data-unit="d"]');
        var elH = countdown.querySelector('[data-unit="h"]');
        var elM = countdown.querySelector('[data-unit="m"]');
        var elS = countdown.querySelector('[data-unit="s"]');
        var daysWrap = countdown.querySelector('[data-flash-days-wrap]');
        var daysSep = countdown.querySelector('[data-flash-days-sep]');

        var pad = function (n) {
          return String(n).padStart(2, '0');
        };

        var timerBox = section.querySelector('[data-flash-timer]');
        var interval = null;

        var tick = function () {
          var diff = target - Date.now();
          if (diff <= 0) {
            /* Deal ended — hide the timer rather than leave it frozen at 00:00:00. */
            if (timerBox) timerBox.hidden = true;
            if (interval) clearInterval(interval);
            return;
          }
          var totalSeconds = Math.floor(diff / 1000);
          var d = Math.floor(totalSeconds / 86400);
          var h = Math.floor((totalSeconds % 86400) / 3600);
          var m = Math.floor((totalSeconds % 3600) / 60);
          var s = totalSeconds % 60;
          if (elD) elD.textContent = pad(d);
          if (elH) elH.textContent = pad(h);
          if (elM) elM.textContent = pad(m);
          if (elS) elS.textContent = pad(s);
          if (d > 0) {
            if (daysWrap) daysWrap.hidden = false;
            if (daysSep) daysSep.hidden = false;
          } else {
            if (daysWrap) daysWrap.hidden = true;
            if (daysSep) daysSep.hidden = true;
          }
        };

        tick();
        interval = setInterval(tick, 1000);
      }

      /* ── Auto-scrolling slider ── */
      var slider = section.querySelector('[data-flash-slider]');
      var track = section.querySelector('[data-flash-track]');
      if (slider && track) {
        var STEP = 320;

        var prevBtn = section.querySelector('[data-flash-prev]');
        var nextBtn = section.querySelector('[data-flash-next]');

        var goNext = function () {
          if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: STEP, behavior: 'smooth' });
          }
        };

        var goPrev = function () {
          if (track.scrollLeft <= 0) {
            track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: -STEP, behavior: 'smooth' });
          }
        };

        if (nextBtn) nextBtn.addEventListener('click', goNext);
        if (prevBtn) prevBtn.addEventListener('click', goPrev);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavor-teaser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript.closest('[data-flavor-teaser]') ||
      document.querySelector('[data-flavor-teaser]');
    if (!root || root.dataset.flavorInit === 'true') return;
    root.dataset.flavorInit = 'true';

    const ROTATE_MS = 5000;

    const tabs = Array.from(root.querySelectorAll('[data-device-tab]'));
    const lists = Array.from(root.querySelectorAll('[data-flavor-list]'));
    const triggers = Array.from(root.querySelectorAll('[data-flavor-trigger]'));
    const cards = Array.from(root.querySelectorAll('[data-flavor-card]'));
    const glow = root.querySelector('[data-flavor-glow]');

    let device = root.querySelector('[data-flavor-trigger][data-device="juul2"]') ? 'juul2' : 'juul1';
    let active = 0;
    let paused = false;
    let timer = null;

    function countFor(dev) {
      return triggers.filter((t) => t.dataset.device === dev).length;
    }

    const ACTIVE_TRIGGER = ['bg-white', 'border-zinc-200', 'shadow-[0_8px_30px_rgba(0,0,0,0.04)]'];
    const IDLE_TRIGGER = ['bg-transparent', 'border-transparent', 'opacity-55', 'hover:opacity-90'];

    function setTrigger(btn, isActive) {
      ACTIVE_TRIGGER.forEach((c) => btn.classList.toggle(c, isActive));
      IDLE_TRIGGER.forEach((c) => btn.classList.toggle(c, !isActive));
    }

    function render() {
      tabs.forEach((tab) => {
        const on = tab.dataset.deviceTab === device;
        tab.classList.toggle('bg-white', on);
        tab.classList.toggle('text-zinc-950', on);
        tab.classList.toggle('shadow-sm', on);
        tab.classList.toggle('text-zinc-500', !on);
        tab.classList.toggle('hover:text-zinc-800', !on);
      });

      lists.forEach((list) => {
        const on = list.dataset.flavorList === device;
        list.classList.toggle('flex', on);
        list.classList.toggle('hidden', !on);
      });

      triggers.forEach((btn) => {
        const isOn = btn.dataset.device === device && Number(btn.dataset.index) === active;
        setTrigger(btn, isOn);
      });

      cards.forEach((card) => {
        const on = card.dataset.device === device && Number(card.dataset.index) === active;
        card.classList.toggle('flex', on);
        card.classList.toggle('hidden', !on);
      });

      const activeTrigger = triggers.find(
        (t) => t.dataset.device === device && Number(t.dataset.index) === active
      );
      if (glow && activeTrigger && activeTrigger.dataset.accent) {
        glow.style.background = 'radial-gradient(circle, ' + activeTrigger.dataset.accent + ' 0%, transparent 60%)';
      }
    }

    function start() {
      stop();
      const count = countFor(device);
      if (count < 2) return;
      timer = setInterval(() => {
        if (paused) return;
        active = (active + 1) % count;
        render();
      }, ROTATE_MS);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        device = tab.dataset.deviceTab;
        active = 0;
        render();
        start();
      });
    });

    triggers.forEach((btn) => {
      btn.addEventListener('click', () => {
        device = btn.dataset.device;
        active = Number(btn.dataset.index);
        render();
        start();
      });
    });

    lists.forEach((list) => {
      list.addEventListener('mouseenter', () => { paused = true; });
      list.addEventListener('mouseleave', () => { paused = false; });
    });

    render();
    start();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["floating-socials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-floating-socials]');
    roots.forEach(function (root) {
      if (root.dataset.fsInit) return;
      root.dataset.fsInit = '1';
      var toggle = root.querySelector('[data-fs-toggle]');
      var menu = root.querySelector('[data-fs-menu]');
      var fab = root.querySelector('[data-fs-fab]');
      var iconChat = root.querySelector('[data-fs-icon-chat]');
      var iconClose = root.querySelector('[data-fs-icon-close]');
      var label = root.querySelector('[data-fs-label]');
      var open = false;
      toggle.addEventListener('click', function () {
        open = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.classList.toggle('hidden', !open);
        menu.classList.toggle('flex', open);
        iconChat.classList.toggle('hidden', open);
        iconClose.classList.toggle('hidden', !open);
        label.classList.toggle('hidden', open);
        if (open) {
          fab.classList.remove('bg-zinc-950', 'text-brand');
          fab.classList.add('bg-brand', 'text-white', 'scale-95');
        } else {
          fab.classList.add('bg-zinc-950', 'text-brand');
          fab.classList.remove('bg-brand', 'text-white', 'scale-95');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.currentScript.closest('footer[data-footer-id]') || document.querySelector('footer[data-footer-id]');
    if (!root) return;

    root.querySelectorAll('.footer-copy').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const value = btn.getAttribute('data-copy-value') || '';
        const copyIcon = btn.querySelector('.footer-copy__copy');
        const checkIcon = btn.querySelector('.footer-copy__check');

        const showCopied = function () {
          btn.classList.add('text-success');
          btn.classList.remove('text-zinc-400');
          if (copyIcon) copyIcon.classList.add('hidden');
          if (checkIcon) checkIcon.classList.remove('hidden');
          setTimeout(function () {
            btn.classList.remove('text-success');
            btn.classList.add('text-zinc-400');
            if (copyIcon) copyIcon.classList.remove('hidden');
            if (checkIcon) checkIcon.classList.add('hidden');
          }, 2000);
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(showCopied).catch(function () {});
        } else {
          const ta = document.createElement('textarea');
          ta.value = value;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); showCopied(); } catch (e) {}
          document.body.removeChild(ta);
        }
      });
    });

    const topBtn = root.querySelector('.footer-scroll-top');
    if (topBtn) {
      topBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            topBtn.classList.toggle('is-visible', entry.isIntersecting);
          });
        }, { threshold: 0 });
        observer.observe(root);
      } else {
        topBtn.classList.add('is-visible');
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["happy-clients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatCount(raw, current) {
      var match = raw.match(/[\d.]+/);
      if (!match) return raw;
      var numStr = match[0];
      var isDecimal = numStr.indexOf('.') !== -1;
      var prefix = raw.slice(0, match.index);
      var suffix = raw.slice(match.index + numStr.length);
      if (isDecimal) return prefix + current.toFixed(1) + suffix;
      var rounded = Math.round(current);
      var withCommas = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return prefix + withCommas + suffix;
    }

    function animateCounter(el) {
      var raw = el.getAttribute('data-hc-counter');
      var match = raw.match(/[\d.]+/);
      if (!match) { el.textContent = raw; return; }
      var end = parseFloat(match[0]);
      var duration = 1500;
      var start = null;

      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        el.textContent = formatCount(raw, progress * end);
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = raw;
        }
      }
      requestAnimationFrame(step);
    }

    var counters = document.querySelectorAll('[data-hc-counter]');

    if (!('IntersectionObserver' in window)) {
      counters.forEach(function (el) { el.textContent = el.getAttribute('data-hc-counter'); });
      document.querySelectorAll('[data-happy-clients]').forEach(function (s) { s.classList.add('is-in-view'); });
      return;
    }

    if (counters.length) {
      var counterObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCounter(entry.target);
            counterObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { counterObserver.observe(el); });
    }

    /* Star "counter" reveal — trigger once per section when it scrolls into
     * view. Watching the section (not each card) sidesteps the marquee's
     * continuous horizontal motion, which makes per-card visibility unstable. */
    var sections = document.querySelectorAll('[data-happy-clients]');
    if (sections.length) {
      var starObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in-view');
            starObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      sections.forEach(function (el) { starObserver.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function paintWishlistCount(count) {
      document.querySelectorAll('[data-wishlist-count]').forEach(function (badge) {
        badge.textContent = count;
        badge.classList.toggle('hidden', count === 0);
      });
    }
    try {
      var storedWishlist = JSON.parse(localStorage.getItem('j1_wishlist') || '[]');
      paintWishlistCount(Array.isArray(storedWishlist) ? storedWishlist.length : 0);
    } catch (e) {}
    window.addEventListener('wishlist:change', function (e) {
      paintWishlistCount(e.detail.count);
    });

    var roots = document.querySelectorAll('[data-scroll-hide]');
    roots.forEach(function (nav) {
      if (nav.dataset.headerInit === 'true') return;
      nav.dataset.headerInit = 'true';

      var toggle = nav.querySelector('[data-menu-toggle]');
      var drawer = nav.querySelector('[data-mobile-drawer]');
      var iconMenu = nav.querySelector('[data-icon-menu]');
      var iconClose = nav.querySelector('[data-icon-close]');

      function closeDrawer() {
        if (!drawer) return;
        drawer.hidden = true;
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (iconMenu) iconMenu.classList.remove('hidden');
        if (iconClose) iconClose.classList.add('hidden');
      }

      if (toggle && drawer) {
        toggle.addEventListener('click', function () {
          var willOpen = drawer.hidden;
          drawer.hidden = !willOpen;
          toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (iconMenu) iconMenu.classList.toggle('hidden', willOpen);
          if (iconClose) iconClose.classList.toggle('hidden', !willOpen);
        });
      }

      var lastY = window.scrollY || window.pageYOffset || 0;
      window.addEventListener('scroll', function () {
        var current = window.scrollY || window.pageYOffset || 0;
        if (current > lastY && current > 50) {
          nav.classList.add('is-hidden');
          closeDrawer();
        } else {
          nav.classList.remove('is-hidden');
        }
        lastY = current;
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var FINISHES = {
      graphite: {
        front: 'linear-gradient(160deg,#27272a,#09090b)',
        back: 'linear-gradient(160deg,#18181b,#27272a)',
        side: '#09090b'
      },
      silver: {
        front: 'linear-gradient(160deg,#d4d4d8,#71717a)',
        back: 'linear-gradient(160deg,#a1a1aa,#d4d4d8)',
        side: '#71717a'
      },
      gold: {
        front: 'linear-gradient(160deg,#fcd34d,#b45309)',
        back: 'linear-gradient(160deg,#d97706,#fbbf24)',
        side: '#92400e'
      }
    };

    var roots = document.querySelectorAll('.hero-3d');
    roots.forEach(function (root) {
      if (root.dataset.heroInit === '1') return;
      root.dataset.heroInit = '1';

      var slidesCopy = root.querySelectorAll('.hero-slide-copy');
      var specs = root.querySelectorAll('.hero-specs');
      var indicators = root.querySelectorAll('.hero-indicator');
      var bars = root.querySelectorAll('.hero-bar');
      var counter = root.querySelector('.hero-counter');
      var prevBtn = root.querySelector('.hero-prev');
      var nextBtn = root.querySelector('.hero-next');

      var dFront = root.querySelector('.hero-device-front');
      var dBack = root.querySelector('.hero-device-back');
      var dSides = root.querySelectorAll('.hero-device-side');
      var halo = root.querySelector('.hero-halo');
      var led = root.querySelector('.hero-led');
      var ringOuter = root.querySelector('.hero-ring-outer');
      var ringInner = root.querySelector('.hero-ring-inner');

      var total = slidesCopy.length;
      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 7000;
      var cur = 0;
      var timer = null;

      if (!total) return;

      function show(i) {
        cur = (i + total) % total;

        slidesCopy.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === cur);
        });
        specs.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === cur);
        });

        indicators.forEach(function (btn, idx) {
          btn.classList.toggle('is-active', idx === cur);
          var bar = bars[idx];
          if (!bar) return;
          if (idx === cur) {
            bar.className = 'hero-bar h-[3px] rounded-full transition-all duration-500 w-10 sm:w-12';
          } else {
            bar.className = 'hero-bar h-[3px] rounded-full transition-all duration-500 w-4 sm:w-5 bg-zinc-300 group-hover:bg-zinc-400';
          }
        });

        if (counter) counter.textContent = String(cur + 1);

        var finish = FINISHES[slidesCopy[cur].getAttribute('data-finish')] || FINISHES.graphite;
        if (dFront) dFront.style.background = finish.front;
        if (dBack) dBack.style.background = finish.back;
        dSides.forEach(function (el) { el.style.background = finish.side; });

        var accent = slidesCopy[cur].getAttribute('data-accent') || '#EF4444';
        if (halo) halo.style.background = 'radial-gradient(circle,' + accent + ' 0%,transparent 65%)';
        if (led) {
          led.style.backgroundColor = accent;
          led.style.boxShadow = '0 0 12px ' + accent + ',0 0 20px ' + accent;
        }
        if (ringOuter) ringOuter.style.borderColor = 'color-mix(in srgb, ' + accent + ' 8%, transparent)';
        if (ringInner) ringInner.style.borderColor = 'color-mix(in srgb, ' + accent + ' 5%, transparent)';
      }

      function next() { show(cur + 1); }
      function prev() { show(cur - 1); }

      function restart() {
        if (timer) clearInterval(timer);
        if (autoplay && total > 1) timer = setInterval(next, interval);
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
      indicators.forEach(function (btn) {
        btn.addEventListener('click', function () {
          show(parseInt(btn.getAttribute('data-index'), 10));
          restart();
        });
      });

      show(0);
      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul-360-viewer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initViewer(root) {
      if (root.dataset.j360Init) return;
      root.dataset.j360Init = '1';

      var box = root.querySelector('[data-j360-box]');
      var device = root.querySelector('[data-j360-device]');
      var readout = root.querySelector('[data-j360-readout]');
      var led = root.querySelector('[data-j360-led]');
      var glow = root.querySelector('[data-j360-glow]');
      var spinSlider = root.querySelector('[data-j360-spin]');
      var zoomSlider = root.querySelector('[data-j360-zoom]');
      var zoomVal = root.querySelector('[data-j360-zoomval]');
      var playBtn = root.querySelector('[data-j360-playpause]');
      var iconPause = root.querySelector('[data-j360-icon-pause]');
      var iconPlay = root.querySelector('[data-j360-icon-play]');
      var card = root.querySelector('[data-j360-card]');
      var colorBtns = root.querySelectorAll('[data-j360-color]');
      var specs = root.querySelectorAll('[data-j360-spec]');

      if (!box || !device || !card || !spinSlider || !zoomSlider || !playBtn) return;

      var rotation = 0, zoom = 1, autoSpin = true, activeColor = '#10B981', frame;

      function specIndex(r) {
        if (r >= 315 || r < 45) return 0;
        if (r < 135) return 1;
        if (r < 225) return 2;
        return 3;
      }
      var lastSpec = -1;
      function render() {
        box.style.transform = 'rotateY(' + rotation + 'deg)';
        device.style.transform = 'scale(' + zoom + ')';
        readout.textContent = Math.round(rotation);
        spinSlider.value = rotation;
        var idx = specIndex(rotation);
        if (idx !== lastSpec) {
          lastSpec = idx;
          specs.forEach(function (s) {
            s.classList.toggle('is-active', parseInt(s.getAttribute('data-j360-spec'), 10) === idx);
          });
        }
      }
      function applyColor(c) {
        activeColor = c;
        if (led) { led.style.backgroundColor = c; led.style.boxShadow = '0 0 12px ' + c + ', 0 0 20px ' + c; }
        if (glow) glow.style.backgroundColor = c;
        spinSlider.style.accentColor = c;
        zoomSlider.style.accentColor = c;
        colorBtns.forEach(function (b) {
          b.style.borderColor = b.getAttribute('data-j360-color') === c ? c : 'transparent';
        });
      }
      function setSpin(on) {
        autoSpin = on;
        iconPause.classList.toggle('hidden', !on);
        iconPlay.classList.toggle('hidden', on);
      }
      function loop() {
        if (autoSpin) { rotation = (rotation + 1.2) % 360; render(); }
        frame = requestAnimationFrame(loop);
      }

      playBtn.addEventListener('click', function () { setSpin(!autoSpin); });
      spinSlider.addEventListener('input', function () { setSpin(false); rotation = Number(spinSlider.value); render(); });
      zoomSlider.addEventListener('input', function () { zoom = Number(zoomSlider.value); zoomVal.textContent = zoom.toFixed(1) + 'x'; device.style.transform = 'scale(' + zoom + ')'; });
      colorBtns.forEach(function (b) { b.addEventListener('click', function () { applyColor(b.getAttribute('data-j360-color')); }); });

      // Drag to spin
      var dragging = false, lastX = 0;
      card.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; setSpin(false); card.setPointerCapture(e.pointerId); });
      card.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = (e.clientX - lastX) * 0.8;
        lastX = e.clientX;
        rotation = (rotation - delta) % 360;
        if (rotation < 0) rotation += 360;
        render();
      });
      card.addEventListener('pointerup', function () { dragging = false; });
      card.addEventListener('pointercancel', function () { dragging = false; });

      render();
      frame = requestAnimationFrame(loop);

      root.j360Destroy = function () {
        cancelAnimationFrame(frame);
      };
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-juul360]').forEach(initViewer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    /* Theme editor re-renders section HTML via AJAX — re-init on load, stop the
     * old rAF loop on unload. */
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-juul360]');
      if (root && root.j360Destroy) root.j360Destroy();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-juul1-grid]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-j1-filter]');
      var cards = root.querySelectorAll('[data-j1-card]');
      var count = root.querySelector('[data-j1-count]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var filter = tab.getAttribute('data-j1-filter');
          var visible = 0;

          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          cards.forEach(function (card) {
            var match = filter === 'all' || card.getAttribute('data-j1-type') === filter;
            card.style.display = match ? '' : 'none';
            if (match) visible++;
          });

          if (count) count.textContent = visible;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-flavors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-j1-flavors]').forEach(function (root) {
      var track = root.querySelector('[data-j1f-track]');
      var prev = root.querySelector('[data-j1f-prev]');
      var next = root.querySelector('[data-j1f-next]');
      if (!track) return;

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -320, behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: 320, behavior: 'smooth' });
      });

      var dots = root.querySelectorAll('[data-j1f-dot]');
      if (dots.length) {
        var updateDots = function () {
          var cardWidth = track.scrollWidth / dots.length;
          var index = Math.round(track.scrollLeft / cardWidth);
          index = Math.max(0, Math.min(dots.length - 1, index));
          dots.forEach(function (dot, i) {
            dot.classList.toggle('bg-zinc-900', i === index);
            dot.classList.toggle('bg-zinc-300', i !== index);
          });
        };
        track.addEventListener('scroll', function () {
          window.requestAnimationFrame(updateDots);
        });
        updateDots();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-info"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-j1-readmore]').forEach(function (root) {
      var content = root.querySelector('[data-j1-readmore-content]');
      var fade = root.querySelector('[data-j1-readmore-fade]');
      var toggle = root.querySelector('[data-j1-readmore-toggle]');
      if (!content || !toggle) return;
      var open = false;

      toggle.addEventListener('click', function () {
        open = !open;
        content.classList.toggle('max-h-56', !open);
        if (fade) fade.classList.toggle('hidden', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-packaging"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-juul1-packaging]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-j1-pack]');
      var flips = root.querySelectorAll('[data-j1-pack-flip]');
      var panels = root.querySelectorAll('[data-j1-panel]');
      var images = root.querySelectorAll('[data-j1-img]');
      var current = 'old';

      function setSlide(target) {
        current = target;
        root.classList.toggle('is-new', target === 'new');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-j1-pack') === target);
        });
        panels.forEach(function (p) { p.hidden = p.getAttribute('data-j1-panel') !== target; });
        images.forEach(function (img) { img.hidden = img.getAttribute('data-j1-img') !== target; });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { setSlide(tab.getAttribute('data-j1-pack')); });
      });
      flips.forEach(function (btn) {
        btn.addEventListener('click', function () { setSlide(current === 'old' ? 'new' : 'old'); });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-product-description"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-j1-richdesc]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-j1-tab]');
      var panels = root.querySelectorAll('[data-j1-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-j1-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-j1-panel') !== target; });
        });
      });

      root.querySelectorAll('[data-j1-readmore]').forEach(function (readmoreRoot) {
        var content = readmoreRoot.querySelector('[data-j1-readmore-content]');
        var fade = readmoreRoot.querySelector('[data-j1-readmore-fade]');
        var toggle = readmoreRoot.querySelector('[data-j1-readmore-toggle]');
        if (!content || !toggle) return;
        var open = false;

        toggle.addEventListener('click', function () {
          open = !open;
          content.classList.toggle('max-h-56', !open);
          if (fade) fade.classList.toggle('hidden', open);
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          toggle.textContent = open ? toggle.dataset.labelLess : toggle.dataset.labelMore;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-j1-product]').forEach(function (root) {
      var variantId = root.getAttribute('data-variant-id');
      var priceCents = parseInt(root.getAttribute('data-price-cents'), 10) || 0;
      var qty = 1;

      var qtyEl = root.querySelector('[data-j1-qty]');
      var totalEl = root.querySelector('[data-j1-total]');
      var stickyTotal = root.querySelector('[data-j1-sticky-total]');
      var stickyOriginal = root.querySelector('[data-j1-sticky-original]');
      var sticky = root.querySelector('[data-j1-sticky]');

      function fmt(cents) {
        return (cents / 100).toFixed(2);
      }

      function addonsTotal() {
        var sum = 0;
        root.querySelectorAll('[data-j1-addon]:checked').forEach(function (cb) {
          sum += parseInt(cb.getAttribute('data-addon-price'), 10) || 0;
        });
        return sum;
      }

      function refresh() {
        var total = (priceCents + addonsTotal()) * qty;
        if (qtyEl) qtyEl.textContent = qty;
        if (totalEl) totalEl.textContent = fmt(total);
        if (stickyTotal) stickyTotal.textContent = fmt(total);
        if (stickyOriginal) stickyOriginal.textContent = fmt(Math.round(total * 1.25));
      }

      var minus = root.querySelector('[data-j1-qty-minus]');
      var plus = root.querySelector('[data-j1-qty-plus]');
      if (minus) minus.addEventListener('click', function () { qty = Math.max(1, qty - 1); refresh(); });
      if (plus) plus.addEventListener('click', function () { qty += 1; refresh(); });

      root.querySelectorAll('[data-j1-addon]').forEach(function (cb) {
        cb.addEventListener('change', function () {
          cb.closest('.j1-addon').classList.toggle('is-checked', cb.checked);
          refresh();
        });
      });

      function buildItems() {
        var items = [{ id: parseInt(variantId, 10), quantity: qty }];
        root.querySelectorAll('[data-j1-addon]:checked').forEach(function (cb) {
          items.push({ id: parseInt(cb.getAttribute('data-addon-variant'), 10), quantity: qty });
        });
        return items;
      }

      function addToCart(redirect) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: buildItems() })
        })
          .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
          .then(function () {
            if (redirect) {
              window.location.href = redirect;
            } else if (window.J1Cart) {
              window.J1Cart.refresh().then(window.J1Cart.open);
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function () { window.location.href = '/cart'; });
      }

      root.querySelectorAll('[data-j1-add]').forEach(function (btn) {
        btn.addEventListener('click', function () { addToCart(null); });
      });
      root.querySelectorAll('[data-j1-buy]').forEach(function (btn) {
        btn.addEventListener('click', function () { addToCart('/checkout'); });
      });

      // Gallery thumbnails
      var slides = root.querySelectorAll('[data-j1-slide]');
      var thumbs = root.querySelectorAll('[data-j1-thumb]');
      var activeIndex = 0;

      function setSlide(idx) {
        activeIndex = idx;
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-j1-slide') !== String(idx); });
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-j1-thumb') === String(idx));
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setSlide(parseInt(t.getAttribute('data-j1-thumb'), 10)); });
      });

      // Lightbox
      var lightbox = root.querySelector('[data-j1-lightbox]');
      var lightboxImg = root.querySelector('[data-j1-lightbox-img]');
      var zoomBtn = root.querySelector('[data-j1-zoom]');
      if (zoomBtn && lightbox && lightboxImg) {
        zoomBtn.addEventListener('click', function () {
          var current = root.querySelector('[data-j1-slide="' + activeIndex + '"] img') || root.querySelector('[data-j1-slide] img');
          if (current) lightboxImg.src = current.currentSrc || current.src;
          lightbox.classList.remove('hidden');
          lightbox.classList.add('flex');
        });
        root.querySelector('[data-j1-lightbox-close]').addEventListener('click', function () {
          lightbox.classList.add('hidden');
          lightbox.classList.remove('flex');
        });
      }

      // Mobile sticky bar
      if (sticky) {
        window.addEventListener('scroll', function () {
          sticky.classList.toggle('is-visible', window.scrollY > 680);
        }, { passive: true });
      }

      refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul1-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-j1-reviews]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-j1-rfilter]');
      var cards = root.querySelectorAll('[data-j1-review]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var filter = tab.getAttribute('data-j1-rfilter');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          cards.forEach(function (card) {
            card.style.display = (filter === 'all' || card.getAttribute('data-rating') === filter) ? '' : 'none';
          });
        });
      });

      root.querySelectorAll('[data-j1-helpful]').forEach(function (btn) {
        var counted = false;
        btn.addEventListener('click', function () {
          if (counted) return;
          counted = true;
          var count = btn.querySelector('[data-j1-helpful-count]');
          if (count) count.textContent = parseInt(count.textContent, 10) + 1;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["juul2-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-juul1-grid]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-j1-filter]');
      var cards = root.querySelectorAll('[data-j1-card]');
      var count = root.querySelector('[data-j1-count]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var filter = tab.getAttribute('data-j1-filter');
          var visible = 0;

          tabs.forEach(function (t) { t.classList.remove('is-active'); });
          tab.classList.add('is-active');

          cards.forEach(function (card) {
            var match = filter === 'all' || card.getAttribute('data-j1-type') === filter;
            card.style.display = match ? '' : 'none';
            if (match) visible++;
          });

          if (count) count.textContent = visible;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  function j1StackPageTables() {
    document.querySelectorAll('.page-content table:not([data-stack-ready])').forEach(function (table) {
      table.setAttribute('data-stack-ready', 'true');

      var headerCells = table.querySelectorAll('thead th');
      if (!headerCells.length) return;

      var labels = Array.prototype.map.call(headerCells, function (th) {
        return th.textContent.trim();
      });

      table.classList.add('table--stacked');

      table.querySelectorAll('tbody tr').forEach(function (row) {
        row.querySelectorAll('td').forEach(function (cell, index) {
          if (labels[index]) cell.setAttribute('data-label', labels[index]);
        });
      });
    });
  }

  j1StackPageTables();
  document.addEventListener('shopify:section:load', j1StackPageTables);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"] && !Shopify.designMode) return;
  try {
    
  function initPasswordGateReveal() {
    document.querySelectorAll('.pw-gate__reveal').forEach((toggle) => {
      if (toggle.dataset.pwBound === 'true') return;

      const input = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!input) return;

      const eye = toggle.querySelector('.pw-gate__eye');
      const eyeOff = toggle.querySelector('.pw-gate__eye-off');
      toggle.dataset.pwBound = 'true';

      toggle.addEventListener('click', () => {
        const revealed = input.type === 'text';
        input.type = revealed ? 'password' : 'text';
        toggle.setAttribute('aria-pressed', String(!revealed));
        eye.classList.toggle('hidden', !revealed);
        eyeOff.classList.toggle('hidden', revealed);
        input.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPasswordGateReveal);
  } else {
    initPasswordGateReveal();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('[data-search-page]').forEach(function (root) {
    /* Predictive search: fetches the predictive-search section via the
       Section Rendering API and shows results in a dropdown panel. */
    var searchInput = root.querySelector('[data-search-input]');
    var suggestPanel = root.querySelector('[data-search-suggest]');
    var predictiveUrl = root.dataset.predictiveUrl;

    if (searchInput && suggestPanel && predictiveUrl) {
      var debounceTimer = null;
      var requestId = 0;

      function closeSuggest() {
        suggestPanel.classList.add('hidden');
        searchInput.setAttribute('aria-expanded', 'false');
      }

      function openSuggest() {
        if (suggestPanel.innerHTML.trim() !== '') {
          suggestPanel.classList.remove('hidden');
          searchInput.setAttribute('aria-expanded', 'true');
        }
      }

      function fetchSuggestions(query) {
        var currentRequest = ++requestId;
        var url =
          predictiveUrl +
          '?q=' + encodeURIComponent(query) +
          '&resources[type]=product&resources[limit]=8&section_id=predictive-search';

        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            if (currentRequest !== requestId) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var results = doc.querySelector('[data-predictive-results]');
            if (results) {
              suggestPanel.innerHTML = results.innerHTML;
              openSuggest();
            } else {
              suggestPanel.innerHTML = '';
              closeSuggest();
            }
          })
          .catch(function () {
            closeSuggest();
          });
      }

      searchInput.addEventListener('input', function () {
        var query = searchInput.value.trim();
        clearTimeout(debounceTimer);

        if (query === '') {
          requestId++;
          suggestPanel.innerHTML = '';
          closeSuggest();
          return;
        }

        debounceTimer = setTimeout(function () {
          fetchSuggestions(query);
        }, 250);
      });

      searchInput.addEventListener('focus', openSuggest);

      searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeSuggest();
      });

      document.addEventListener('click', function (event) {
        if (!searchInput.closest('[data-search-form]').contains(event.target)) {
          closeSuggest();
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ws-catalog]').forEach(function (root) {
    var track = root.querySelector('[data-ws-track]');
    var prev = root.querySelector('[data-ws-prev]');
    var next = root.querySelector('[data-ws-next]');
    if (!track) return;
    function step() {
      var card = track.querySelector('div');
      var w = card ? card.getBoundingClientRect().width : 300;
      return w + 28;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-hero"] && !Shopify.designMode) return;
  try {
    
  // Counter animation on scroll
  (function () {
    var counters = document.querySelectorAll('[data-ws-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          if (el.dataset.animated === '1') return;
          el.dataset.animated = '1';

          var target = parseInt(el.dataset.wsCounter, 10) || 0;
          var prefix = el.dataset.wsPrefix || '';
          var suffix = el.dataset.wsSuffix || '';
          var duration = 1600;
          var startTime = null;

          function animateCount(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var easeProgress = 1 - Math.pow(1 - progress, 3);
            var current = Math.floor(easeProgress * target);

            el.textContent = prefix + current + suffix;

            if (progress < 1) {
              requestAnimationFrame(animateCount);
            } else {
              el.textContent = prefix + target + suffix;
            }
          }

          requestAnimationFrame(animateCount);
        }
      });
    }, { threshold: 0.2 });

    counters.forEach(function (c) { observer.observe(c); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-wishlist-page]').forEach(function (root) {
      if (root.dataset.wishlistPageInit === 'true') return;
      root.dataset.wishlistPageInit = 'true';

      var loadingEl = root.querySelector('[data-wishlist-loading]');
      var emptyEl = root.querySelector('[data-wishlist-empty]');
      var gridEl = root.querySelector('[data-wishlist-grid]');
      var addLabel = root.getAttribute('data-add-to-cart-label') || 'Add to Cart';

      function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str || '';
        return div.innerHTML;
      }

      function fmtMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
          return window.Shopify.currency.active + ' ' + amount;
        }
        return amount;
      }

      function bestVariant(product) {
        var variants = product.variants || [];
        var available = variants.filter(function (v) { return v.available; });
        return available[0] || variants[0] || null;
      }

      function cardHtml(product) {
        var variant = bestVariant(product);
        var available = variant ? variant.available : false;
        var price = variant ? variant.price : product.price;
        var comparePrice = variant ? variant.compare_at_price : product.compare_at_price;
        var hasCompare = comparePrice && comparePrice > price;
        var image = product.featured_image || (product.images && product.images[0]) || '';
        var imgTag = image
          ? '<img src="' + image + (image.indexOf('?') === -1 ? '?' : '&') + 'width=600" alt="" loading="lazy" class="object-contain w-full h-full drop-shadow-xl">'
          : '';

        var discountBadge = '';
        if (hasCompare) {
          var pct = Math.round(((comparePrice - price) * 100) / comparePrice);
          discountBadge =
            '<span class="absolute top-3 left-3 z-10 px-2.5 py-1 rounded-full text-white text-[10px] font-black uppercase tracking-wider shadow-md bg-success">-' +
            pct + '% OFF</span>';
        }

        var priceRow = '<span class="text-lg font-black text-zinc-950">' + fmtMoney(price) + '</span>';
        if (hasCompare) {
          priceRow += '<span class="text-xs line-through text-zinc-400 ml-2">' + fmtMoney(comparePrice) + '</span>';
        }

        var actionHtml;
        if (available && variant) {
          actionHtml =
            '<button type="button" data-wishlist-add data-variant-id="' + variant.id + '" class="flex items-center gap-1.5 font-bold text-[10px] uppercase tracking-wider px-4 py-2 rounded-full transition-all duration-300 cursor-pointer bg-zinc-950 hover:bg-brand text-white shadow-md shadow-zinc-950/10">' +
            '<svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
            escapeHtml(addLabel) +
            '</button>';
        } else {
          actionHtml =
            '<span class="flex items-center gap-1.5 font-bold text-[10px] uppercase tracking-wider px-4 py-2 rounded-full bg-zinc-100 text-zinc-400 cursor-not-allowed">Sold out</span>';
        }

        return (
          '<div class="group relative flex flex-col justify-between rounded-3xl p-5 border transition-all duration-300 bg-white border-zinc-200/80 shadow-[0_8px_30px_rgba(0,0,0,0.02)] hover:border-zinc-300/80 hover:shadow-[0_20px_50px_rgba(0,0,0,0.06)]" data-wishlist-card data-product-handle="' + product.handle + '">' +
          '<div class="w-full h-72 rounded-2xl border relative overflow-hidden flex items-center justify-center transition-colors bg-zinc-50 border-zinc-100">' +
          discountBadge +
          '<button type="button" class="j1-wishlist-btn is-active absolute top-3 right-3 z-10 p-1.5 rounded-full border transition-all bg-white hover:bg-zinc-100 border-zinc-200 text-zinc-400 hover:text-zinc-700 cursor-pointer" data-wishlist-toggle data-product-handle="' + product.handle + '" aria-pressed="true" aria-label="Remove from wishlist">' +
          '<svg class="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5"/></svg>' +
          '</button>' +
          '<a href="' + product.url + '" class="w-full h-full flex items-center justify-center transition-transform duration-300 group-hover:scale-[1.08] group-hover:-rotate-[5deg]">' + imgTag + '</a>' +
          '</div>' +
          '<div class="mt-5 space-y-2 text-left flex-1">' +
          '<h3 class="text-base font-bold transition-colors text-zinc-900"><a href="' + product.url + '" class="hover:text-brand cursor-pointer">' + escapeHtml(product.title) + '</a></h3>' +
          '</div>' +
          '<div class="flex items-center justify-between pt-4 mt-4 border-t border-zinc-100">' +
          '<div class="flex items-end flex-wrap gap-x-2 gap-y-1">' + priceRow + '</div>' +
          actionHtml +
          '</div>' +
          '</div>'
        );
      }

      function render(products) {
        loadingEl.classList.add('hidden');
        if (!products.length) {
          emptyEl.classList.remove('hidden');
          gridEl.classList.add('hidden');
          gridEl.innerHTML = '';
          return;
        }
        emptyEl.classList.add('hidden');
        gridEl.innerHTML = products.map(cardHtml).join('');
        gridEl.classList.remove('hidden');
      }

      function load() {
        var handles = window.J1Wishlist ? window.J1Wishlist.getAll() : [];
        if (!handles.length) {
          render([]);
          return;
        }
        Promise.all(
          handles.map(function (handle) {
            return fetch('/products/' + handle + '.js')
              .then(function (r) { return r.ok ? r.json() : null; })
              .catch(function () { return null; });
          })
        ).then(function (results) {
          var found = [];
          results.forEach(function (product, i) {
            if (product) {
              found.push(product);
            } else if (window.J1Wishlist) {
              window.J1Wishlist.remove(handles[i]);
            }
          });
          render(found);
        });
      }

      gridEl.addEventListener('click', function (e) {
        var removeBtn = e.target.closest('[data-wishlist-toggle]');
        if (removeBtn) {
          var card = removeBtn.closest('[data-wishlist-card]');
          if (card) card.remove();
          if (!gridEl.children.length) render([]);
          return;
        }

        var addBtn = e.target.closest('[data-wishlist-add]');
        if (addBtn) {
          var variantId = addBtn.getAttribute('data-variant-id');
          if (!variantId) return;
          if (window.J1Cart) {
            window.J1Cart.add([{ id: variantId, quantity: 1 }]);
          } else {
            fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });
          }
        }
      });

      load();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
